/**
 * Restore TipTap editor markdown without NeoAi reveal animation.
 */

export function captureEditorMarkdown(editor) {
  if (!editor || typeof editor.getMarkdown !== "function") return "";
  return editor.getMarkdown();
}

export function restoreEditorMarkdown(editor, markdown) {
  if (!editor?.commands?.setContent) return false;
  editor.commands.setContent(typeof markdown === "string" ? markdown : "", {
    contentType: "markdown",
    parseOptions: { preserveWhitespace: false },
  });
  return true;
}

export function createNeoAiUndoStack(maxDepth = 12) {
  const stack = [];

  return {
    push(snapshot) {
      if (typeof snapshot !== "string") return;
      stack.push(snapshot);
      while (stack.length > maxDepth) {
        stack.shift();
      }
    },
    undo(editor) {
      const prev = stack.pop();
      if (prev == null) return false;
      return restoreEditorMarkdown(editor, prev);
    },
    canUndo() {
      return stack.length > 0;
    },
    clear() {
      stack.length = 0;
    },
  };
}
